import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { useGetUsersQuery } from './users.api';
import Avvvatars from 'avvvatars-react';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Users = () => {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { data, isLoading } = useGetUsersQuery({
    page,
    perPage,
    search,
  });
  const navigate = useNavigate();

  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Users"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.USERS.title, link: Routes.USERS.link },
        ]}
        furtherActions={[{ value: 'create', display: 'Create User' }]}
        onAction={async (action) => {
          switch (action) {
            case 'create':
              dispatch(
                open({
                  title: 'Create User',
                  contentKey: 'create-user',
                })
              );
              break;
          }
        }}
      />
      <Card>
        <CardContent>
          <FilterBar
            //search={true}
            value={{}}
            filters={[]}
            // onFilterChanged={(values) => {
            //   setStatus(values['status']);
            // }}
            onSearch={(term) => {
              setSearch(term === '' ? undefined : term);
            }}
          />
        </CardContent>
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Email</th>
              <th>Name</th>
              <th>Auth level</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((u) => (
              <tr
                onClick={() => {
                  navigate(`${u._id}`);
                }}
                key={u._id.toString()}
              >
                <td>
                  {/* <Avatar
                    style={{ width: '3.5rem', height: '3.5rem' }}
                    {...genConfig(`${u.firstName} ${u.lastName}`)}
                  /> */}
                  <Avvvatars value={`${u.firstName?.[0]}${u.lastName?.[0]}`} />
                  {/* <Avatar
                    initials={
                      (u.firstName?.[0] ?? '') + (u.lastName?.[0] ?? '')
                    }
                  /> */}
                </td>
                <td>{u.email}</td>
                <td>
                  {u.firstName} {u.lastName}
                </td>
                <td>{u.auth_level}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
